<template>
  <!-- 热点分析 -->
  <el-row>
    <div class="bannerImg"></div>
    <div>
      <el-row class="newsWritePageContainer">
        <el-col :span="21">
          <el-tabs v-model="hotPointRadio" @tab-click="handleHotPointClick">
            <template>
              <el-tab-pane v-for="item in hotPointTags" :name="item.name" :label="item.name"
                :key="item.name"></el-tab-pane>
            </template>
          </el-tabs>
        </el-col>
        <el-col :span="2" :offset="1">
          <el-select style="width:75px" v-model="sortType" placeholder="请选择" class="sortType">
            <el-option label="时间" value="sortTime"> </el-option>
            <el-option label="热度" value="sortHot">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
    </div>
    <div>
      <ul class="listContainer scrollContainer" v-infinite-scroll="loadMore" :infinite-scroll-delay=500
        :infinite-scroll-distance=100 :infinite-scroll-immediate=true :infinite-scroll-disabled='infiniteFinish'>
        <div v-for="(item) in hostPoints" :key="item.hotId" class="infinite-list-item">
          <hotPointCard :url="item.url" :imgSrc="item.imgUrl" :tag="hotPointRadio" :title="item.title" :isVip="isVip"
            :centerId="item.centerId" :content="item.content" :pubTime="item.shortTime" :hotNum="item.centerIndex">
          </hotPointCard>
        </div>
        <div style="clear:both"></div>
        <template v-if="infiniteFinish">
          <div class="noData">
            <i class="iconfont">&#xe629;</i>
            <template v-if="hostPoints && hostPoints.length > 0">
              数据加载完毕!
            </template>
            <template v-else>
              没有相关新闻!
            </template>
          </div>
        </template>
        <template v-else>
          <div class="noData">
            <span class="icon_run">
              <i class="iconfont">&#xe67b;</i>
            </span>数据加载中...
          </div>
        </template>
      </ul>
    </div>
  </el-row>
</template>

<script>

import hotPointCard from '../../components/hot_point_card'
import Loading from '../js/Loading.vue'
import * as appJs from '../../assets/js/app.js'
export default {
  name: 'index',
  data: function () {
    return {
      keyword: '',
      hotSearchActiveName: '1',
      hotPointTags: [],
      totalHotList: [],
      baiduHotList: [],
      sougouHotList: [],
      zhihuHotList: [],
      xinlangHotList: [],
      hotPointRadio: '快讯',
      hostPoints: [],
      pageSize: 15,
      page: 1,
      total: 0,
      sortType: 'sortTime',
      infiniteFinish: false,
      hotSearchLoading: true,
      hotSearchGroup: 0,
      quikPage: 1,
      quikLoading: true,
      hotKey: '',
      hotTimer: null,
      isVip: false

    }
  },

  methods: {
    handleHotPointClick (tab) {
      this.infiniteFinish = false
      this.hostPoints = []
      this.page = 1
      this.total = 0
      this.hotPoint(true)
    },

    hotPoint (noLoading) {
      let _this = this
      Loading.silentLoading()
      let curKey = _this.hotPointRadio
      this.axios.post('/webApi/v3/hot/system-list', { 'tag': _this.hotPointRadio, 'pageSize': _this.pageSize, 'page': _this.page, 'sortType': _this.sortType, 'keywords': _this.hotKey }).then((response) => {
        if (curKey === _this.hotPointRadio) {
          _this.hostPoints = _this.hostPoints.concat(response.data.rows)
          _this.total = response.data.total
          if (response.data.rows.length < 10) {
            _this.infiniteFinish = true
          }
        }
      })
    },

    loadMore () {
      this.page = this.page + 1
      this.hotPoint(true)
    },
    getHotPointsTab () {
      let _this = this
      this.axios.get('/webApi/v3/hotToipcMenu/list?rmQuick=true').then(resp => {
        _this.hotPointTags = resp.data
        _this.hotPointRadio = _this.hotPointTags[0].name
        _this.hotPoint(true)
      })
    }
  },
  components: {

    hotPointCard
  },
  watch: {
    sortType: function () {
      this.page = 1
      this.hostPoints = []
      this.hotPoint(true)
    },
    hotKey: function () {
      this.infiniteFinish = false
      this.hostPoints = []
      if (this.hotTimer) {
        clearTimeout(this.hotTimer)
      }
      let _this = this
      this.hotTimer = setTimeout(function () {
        _this.hotPoint()
      }, 1000)
    }
  },
  mounted () {
    this.getHotPointsTab()
    appJs.isVip().then(val => {
      this.isVip = true
    })
  }
}
</script>
<style lang="less">
.newsWritePageContainer {
  margin-top: 10px;

  .sortType {
    border-radius: 6px;
    background: rgba(246, 249, 253, 1) !important;

    .el-input__inner {
      background: rgba(246, 249, 253, 1) !important;
    }
  }

  .el-tabs__active-bar {
    display: none;
  }

  .el-tabs__item {
    width: 70px;
    height: 40px;
    opacity: 1;
    border-radius: 10px;
    background: rgba(139, 139, 167, 0.08);
    line-height: 26px;
    justify-content: center;
    align-items: center;
    padding: 8px 20px 8px 20px !important;
    display: inline-block;
    margin-left: 10px;
  }

  .is-active {
    color: rgba(42, 130, 228, 1);
    background: rgba(226, 233, 254, 1);
  }

  .el-tabs__nav-wrap::after {
    display: none !important;

  }
}
</style>
<style lang="less" scoped>
.writeDialog {
  width: 1046px !important;
  border-radius: 15px;

  .bannerImg {
    width: 1007px;
    height: 167px;
    background-image: url('../../assets/imgs/newsBanner.png');
  }

  .listContainer {
    height: 400px;
    overflow-y: scroll;
    padding-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/write/news.vue